import React, { Component } from 'react';
import '../css/menubar.css';
import menu from "../resources/menu.json";
import { Link } from 'react-router-dom';

class MenuBar extends Component {
   render() {
      return (
        <nav >
            <ul >
                {
                    menu.map(i => {
                        if(i.menuDropdown.length > 0)
                        {
                            return (
                                <li key={i.menuOptionId}>
                                    {i.mnuMajorPage  
                                        ? <Link to={i.path} style={linkStyle}>{i.menuOptionTitle}</Link>
                                        : i.menuOptionTitle}
                                    <ul class="drop-menu">
                                        {i.menuDropdown.map(l => {
                                            return  (
                                                    <li key={l.ddItemId}>
                                                        <Link to={l.path}
                                                            style={subLinkStyle}>{l.ddItemTitle}</Link>
                                                    </li>
                                                );
                                        })}
                                    </ul>
                                </li>);
                        }
                        else
                        {
                            return (
                                <li key={i.menuOptionId}>
                                    <Link to={i.path}
                                        style={linkStyle}>{i.menuOptionTitle}</Link>
                                </li>
                            );
                        }
                    })
                }
            </ul>
        </nav>
      );
   }
}

export default MenuBar;

const linkStyle = {textDecoration: "none", color: "#3da290", paddingLeft: "1.5vw", paddingRight: "1.5vw", display: 'block'};
const subLinkStyle = {textDecoration: "none", color: "white", paddingLeft: "1vw", paddingRight: "1vw", display: 'block'};